//Параметры запроса получения списка узлов в модуле 
// Пример для модуля docs
//  заданные параметры {method: "findAll", module: "docs", type: "document", condition: "ParId=1294"}
//  будут пробразованы в  {method: "findAll", params: {module: "docs", type: "document", condition: "ParId=1294"}}
export const  nodesGetParams = {
    method :"findAll",
	module: "",
    type: "",
    condition: ""
 }

//Параметры запроса получения узлов по их NodId
export const nodesGetByIdsParams = {
    method :"findByIds",
	module: "",
    type: "",
    ids: []
 }
//Параметры запроса получения списка типов в модуле
export const typesInModuleGetParams = {
    method :"types",
	module: ""
}

//Параметры запроса получения описания типа в модуле
export const typeGetParams = {
    method :"fields",
    module: "",
    type: ""
}

//Параметры запроса получения URL на картинку PlantUML
export const typePlantUMLParams = {
    method :"umlscript",
    script: ""
}

//Параметр запроса получчения URL для скачивания XSD файла
export const typeXSDParams = {
    method :"xsdfile",
    NodId: 0,
    URI: ""
}
